// extracted by mini-css-extract-plugin
export default {"label":"label__w48pylgVFmbe","content":"content__c9nojASbgiNm","expandIcon":"expandIcon__xTJcMM2nV9MO","isOpen":"isOpen__DEntk1BzGJev"};